import React, { useRef } from 'react'
import LadderNumberField from './build_scenario_row_input/LadderNumberField'
import LadderPercentField from './build_scenario_row_input/LadderPercentField'
import CustomIcons from '../../../../../ui_reusable/CustomIcons'
import useBuildScenarioStore from '../../../stores/buildScenarioStore'
import { Container } from './styles/BuildScenarioRowInput.styles'
import theme from '../../../../../../styles/theme'

const BuildScenarioRowInput = ({ scenarioId, rowData, driverId }) => {
  const containerRef = useRef(null)
  const refreshScenarioDriverValue = useBuildScenarioStore(
    (state) => state.refreshScenarioDriverValue,
  )
  const calculateDriverInputBounds = useBuildScenarioStore(
    (state) => state.calculateDriverInputBounds,
  )

  const { minValue, maxValue, steps } = calculateDriverInputBounds(driverId)

  const handleRefreshClick = () => {
    refreshScenarioDriverValue(scenarioId, driverId)
  }

  return (
    <Container ref={containerRef}>
      <LadderNumberField
        scenarioId={scenarioId}
        driverId={driverId}
        min={minValue}
        max={maxValue}
        step={steps}
      />
      <LadderPercentField
        scenarioId={scenarioId}
        driverId={driverId}
        min={minValue}
        max={maxValue}
        step={steps}
      />
      <CustomIcons.faRotateRight
        size="small"
        onClick={handleRefreshClick}
        color={theme.colors.veryVeryFadedText}
        hoverColor={theme.colors.fadedText}
      />
    </Container>
  )
}

export default BuildScenarioRowInput
